import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { cloneDeep } from 'lodash'

import { settingsStore } from '@/store'
import commonTranslations from './language.definitions'
import { FALLBACK_LOCALE } from '@/commons/constants/locale'

Vue.use(VueI18n)

export default new VueI18n({
    locale: settingsStore.verifiedLocale,
    fallbackLocale: FALLBACK_LOCALE,
    messages: cloneDeep(commonTranslations)
})
